<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img8_1" src="images/img8_1.jpg"/></p>
<p class="caption">Outside the National Guard Armoury in New York City when the call went out for the first volunteers. 4US</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01c_AMERICAN_EXPEDITIONARY_FORCE.vue?781b74a5